/**
 * Normalizes the Success field from RPC responses.
 * APIs may return true (boolean), 1 (number), or "1" (string) for success.
 */
export const isSuccess = (value) =>
    value === true || value === 1 || value === "1";
